import {
  vs2jen2GlobalReleaseConstants,
  addVs2jen2GlobalReleaseConstants,
  editVs2jen2GlobalReleaseConstants,
} from "../_redux-constants";

export function vs2jen2GlobalReleaseReducer(
  state = {
    vs2jen2GlobalReleaseLoading: false,
    vs2jen2GlobalReleaseData: null,
    vs2jen2GlobalReleaseError: null,

    addVs2jen2GlobalReleaseLoading: false,
    addVs2jen2GlobalReleaseData: null,
    addVs2jen2GlobalReleaseError: null,

    editVs2jen2GlobalReleaseLoading: false,
    editVs2jen2GlobalReleaseData: null,
    editVs2jen2GlobalReleaseError: null,
  },
  action
) {
  switch (action.type) {
    case vs2jen2GlobalReleaseConstants.VS2JEN2_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        vs2jen2GlobalReleaseLoading: true,
        vs2jen2GlobalReleaseData: null,
        vs2jen2GlobalReleaseError: null,
        addVs2jen2GlobalReleaseLoading: false,
        addVs2jen2GlobalReleaseData: null,
        addVs2jen2GlobalReleaseError: null,
      });
    case vs2jen2GlobalReleaseConstants.VS2JEN2_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        vs2jen2GlobalReleaseLoading: false,
        vs2jen2GlobalReleaseData: action.data,
      });
    case vs2jen2GlobalReleaseConstants.VS2JEN2_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        vs2jen2GlobalReleaseLoading: false,
        vs2jen2GlobalReleaseData: null,
        vs2jen2GlobalReleaseError: action.error,
      });

    case addVs2jen2GlobalReleaseConstants.ADD_VS2JEN2_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        addVs2jen2GlobalReleaseLoading: true,
        addVs2jen2GlobalReleaseData: null,
        addVs2jen2GlobalReleaseError: null,
      });
    case addVs2jen2GlobalReleaseConstants.ADD_VS2JEN2_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        addVs2jen2GlobalReleaseLoading: false,
        addVs2jen2GlobalReleaseData: action.data,
      });
    case addVs2jen2GlobalReleaseConstants.ADD_VS2JEN2_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        addVs2jen2GlobalReleaseLoading: false,
        addVs2jen2GlobalReleaseData: null,
        addVs2jen2GlobalReleaseError: action.error,
      });

    case editVs2jen2GlobalReleaseConstants.EDIT_VS2JEN2_GLOBAL_RELEASE_LOADING:
      return Object.assign({}, state, {
        editVs2jen2GlobalReleaseLoading: true,
        editVs2jen2GlobalReleaseData: null,
        editVs2jen2GlobalReleaseError: null,
      });
    case editVs2jen2GlobalReleaseConstants.EDIT_VS2JEN2_GLOBAL_RELEASE_SUCCESS:
      return Object.assign({}, state, {
        editVs2jen2GlobalReleaseLoading: false,
        editVs2jen2GlobalReleaseData: action.data,
      });
    case editVs2jen2GlobalReleaseConstants.EDIT_VS2JEN2_GLOBAL_RELEASE_FAILURE:
      return Object.assign({}, state, {
        editVs2jen2GlobalReleaseLoading: false,
        editVs2jen2GlobalReleaseData: null,
        editVs2jen2GlobalReleaseError: action.error,
      });

    default:
      return state;
  }
}
